export default __webpack_public_path__ + "static/media/partner1.0349ad01.png";